import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=20170b2a&scoped=true"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=20170b2a&lang=css"
import style1 from "./AppLayout.vue?vue&type=style&index=1&id=20170b2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20170b2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20170b2a')) {
      api.createRecord('20170b2a', component.options)
    } else {
      api.reload('20170b2a', component.options)
    }
    module.hot.accept("./AppLayout.vue?vue&type=template&id=20170b2a&scoped=true", function () {
      api.rerender('20170b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AppLayout.vue"
export default component.exports